import {Dispatch, SetStateAction} from "react";
import {saveToLocalStorage} from "@/app/[locale]/common/utils/functions/saveToLocalStorage/saveToLocalStorage";
import {
    extractDescriptionProjectFromJSON
} from "@/app/[locale]/common/utils/functions/extractDescriptionProjectFromJSON/extractDescriptionProjectFromJSON";
import {GENERAL_URL, STATUS_CODE} from "@/app/[locale]/common/constants/app";
import {TAllProjectItem, TAllProjects} from "@/app/[locale]/projects/types";

export const getAllProjects = async (currentPage: number, setData?:  Dispatch<SetStateAction<TAllProjectItem[] | null>>, setRowTotalCount?: Dispatch<SetStateAction<number>>) => {
    try {
        const res = await fetch(`${GENERAL_URL}/projects?page=${currentPage}&size=3`, {cache: 'no-store'});

        if (res.status === STATUS_CODE.SUCCESS) {
            const data: TAllProjects = await res.json();
            if (setData) {
                const projects = extractDescriptionProjectFromJSON(data.items);
                setData(projects);
            }

            if (setRowTotalCount) {
                setRowTotalCount(data.rowTotalCount);
            }

            if (currentPage === 1) {
                saveToLocalStorage('projects', data.items);
                saveToLocalStorage('projectsRowTotalCount', data.rowTotalCount);
            }
        }

    } catch (err) {
        console.log(err);
    }
};